export default __webpack_public_path__ + "static/media/3.2a095275.svg";